import {Box} from '@mui/material';
import './styles';

import PaymentLinkFooter from '@/app/main/paymentLink/components/PaymentLinkFooter/PaymentLinkFooter';
import {COLORS} from '@/styles/colors';

import {
  PaymentLinkError,
  PaymentLinkExpired,
  PaymentLinkFees,
  PaymentLinkForm,
  PaymentLinkQR,
} from './components';
import PaymentLinkHeader from './components/PaymentLinkHeader/PaymentLinkHeader';
import {
  PaymentLinkViewModelProvider,
  usePaymentLinkViewModelProvider,
} from './ViewModelContext';

const PaymentLinkContent = () => {
  const {
    paymentLinkData,
    paymentLinkError,
    isLinkExpired,
    isLinkNotFound,
    feesData,
    selectedFee,
    setSelectedFee,
    isFetchingPaymentLink,
    selectedAmount,
    setSelectedAmount,
    disableFees,
    setIsSelectTabAmount,
    isSelectTabAmount,
    handleOnCustomAmountClick,
  } = usePaymentLinkViewModelProvider();

  return (
    <>
      {!isFetchingPaymentLink && (
        <section
          className={`payment-link-background ${selectedFee ? 'payment-link-background-for-form' : ''}`}>
          <Box
            className={`payment-link-container ${selectedFee ? 'payment-link-container-for-form' : ''}`}>
            {isLinkNotFound || paymentLinkError ? (
              <PaymentLinkError isNotFoundError={isLinkNotFound} />
            ) : !!paymentLinkData?.single_payment ? (
              <>
                {selectedFee ? (
                  <PaymentLinkForm
                    isSelectTabAmount={isSelectTabAmount}
                    name={paymentLinkData?.receiver_user?.name ?? ''}
                    selectedFee={selectedFee}
                    amount={paymentLinkData?.amount}
                  />
                ) : (
                  <>
                    {feesData ? (
                      <>
                        <PaymentLinkHeader
                          name={paymentLinkData?.receiver_user?.name ?? ''}
                          gif={paymentLinkData.gif}
                          note={paymentLinkData.note}
                          amount={paymentLinkData?.amount}
                          isLink={true}
                          onCustomAmountClick={handleOnCustomAmountClick}
                        />
                        <PaymentLinkFees fees={feesData?.fees} />
                        <PaymentLinkFooter
                          showMoneyGoesBox
                          name={paymentLinkData?.receiver_user?.name ?? ''}
                        />
                      </>
                    ) : (
                      <>
                        {isLinkExpired && (
                          <PaymentLinkExpired
                            name={paymentLinkData?.receiver_user?.name ?? ''}
                          />
                        )}
                        {!isLinkExpired &&
                          !isLinkNotFound &&
                          paymentLinkData && (
                            <PaymentLinkFees fees={feesData?.fees} />
                          )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {selectedFee ? (
                  <PaymentLinkForm
                    isSelectTabAmount={isSelectTabAmount}
                    name={paymentLinkData?.receiver_user?.name ?? ''}
                    selectedFee={selectedFee}
                    amount={selectedAmount}
                  />
                ) : (
                  <>
                    <PaymentLinkHeader
                      name={paymentLinkData?.receiver_user?.name ?? ''}
                    />
                    <PaymentLinkQR
                      optionsColors={{
                        backgroundColor: COLORS.PASTEL_E,
                        backgroundColorHover: COLORS.JAGGED_ICE,
                        colorText: COLORS.ON_SURFACE_1,
                      }}
                      setIsSelectTabAmount={setIsSelectTabAmount}
                      feesData={feesData}
                      setSelectedFee={setSelectedFee}
                      selectedAmount={selectedAmount}
                      setSelectedAmount={setSelectedAmount}
                      disableFees={disableFees}
                    />
                    <PaymentLinkFooter
                      name={paymentLinkData?.receiver_user?.name ?? ''}
                      showMoneyGoesBox
                      isQR
                    />
                  </>
                )}
              </>
            )}
          </Box>
        </section>
      )}
    </>
  );
};

const PaymentLinkPage = () => (
  <PaymentLinkViewModelProvider>
    <PaymentLinkContent />
  </PaymentLinkViewModelProvider>
);

export default PaymentLinkPage;
